import React from 'react'
import { Skeleton } from '@chakra-ui/react'

export const OneLineTextLoader = () => {
  return <Skeleton h='30px' w='90%' borderRadius={5} />
}
